var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HTTP_URL_REGEX } from "./validationUtils";
import { hasImageLinkExtension, hasPdfLinkExtension, isImageResourceType, isTableOfContentsType, requiresImageMode, } from "./resourceImageRules";
/**
 * True when the user edited the link after an upload, i.e. the resource no
 * longer points at the uploaded file and must drop its storage metadata.
 * Compared after trimming — the saved link is trimmed too, so surrounding
 * whitespace is not an edit.
 */
export var isLinkDetachedFromStorage = function (draft, uploadedLink) { var _a; return draft.storageKey !== undefined && ((_a = draft.link) === null || _a === void 0 ? void 0 : _a.trim()) !== (uploadedLink === null || uploadedLink === void 0 ? void 0 : uploadedLink.trim()); };
var stripStorageMetadata = function (draft) { return (__assign(__assign({}, draft), { storageKey: undefined, mimeType: undefined, fileSize: undefined })); };
/**
 * Validates the resource modal draft and returns the value to hand to the
 * title form. Every link — an uploaded one included — must be an absolute
 * http(s) URL: the title schema applies the same rule and the backend never
 * returns a relative public URL, so a failure here means a misconfigured
 * server (APP_PUBLIC_URL), not a user mistake we should silently accept.
 * Image content types (ONIX list 158 codes 01–10) additionally need the Image
 * mode and a jpg/jpeg/png/gif link; a table of contents (code 25) needs a .pdf
 * link (issue #75957).
 */
export var finalizeResourceDraft = function (draft, uploadedLink) {
    var _a, _b, _c, _d;
    var link = (_b = (_a = draft.link) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : "";
    if (!((_c = draft.type) === null || _c === void 0 ? void 0 : _c.value) || !((_d = draft.mode) === null || _d === void 0 ? void 0 : _d.value) || !link) {
        return { error: "required" };
    }
    if (!HTTP_URL_REGEX.test(link)) {
        return { error: "invalidLink" };
    }
    if (requiresImageMode(draft.type, draft.mode)) {
        return { error: "invalidImageMode" };
    }
    if (isImageResourceType(draft.type) && !hasImageLinkExtension(link)) {
        return { error: "invalidImageLink" };
    }
    if (isTableOfContentsType(draft.type) && !hasPdfLinkExtension(link)) {
        return { error: "invalidPdfLink" };
    }
    var withLink = __assign(__assign({}, draft), { link: link });
    return {
        draft: isLinkDetachedFromStorage(draft, uploadedLink)
            ? stripStorageMetadata(withLink)
            : withLink,
    };
};
